import React, { useState } from "react";
import { Bell } from "lucide-react";
import { useQuery } from "@apollo/client/react";
import { GET_UNREAD_NOTIFICATIONS_COUNT } from "../../graphql/queries/notification";
import { useAuth } from "../../hooks/useAuth";
import { NotificationCenter } from "./NotificationCenter";

export function NotificationBell() {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();

  const { data, refetch } = useQuery(GET_UNREAD_NOTIFICATIONS_COUNT, {
    variables: { userId: user?.id || "" },
    skip: !user?.id,
    pollInterval: 30000, // Poll every 30 seconds for updates
  });

  const unreadCount = data?.unreadNotifications || 0;

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="relative p-2 text-secondary-400 hover:text-secondary-500 hover:bg-secondary-100 rounded-full transition-colors"
      >
        <Bell className="h-6 w-6" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>

      <NotificationCenter isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
